import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import YTable from '@/views/components/table/index.vue';
import { listDealerUserManufacturer } from '@/api/manufacturer.js';
import { listCustom, deleteCustom } from '@/api/custom.js';
import { listClientType } from '@/api/dict.js';
import FormComponent from './components/form/index.vue';
export default {
  name: 'base-custom-index',
  components: {
    YTable: YTable,
    FormComponent: FormComponent
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.initialized) {
        vm.loadData();
      }
    });
  },
  data: function data() {
    var _this = this;

    return {
      searchFormExpand: false,
      dataLoading: false,
      dataList: [],
      clientTypeList: [],
      searchForm: {
        manuId: null,
        clientType: null,
        username: null,
        mark: null,
        total: 0,
        page: 1,
        pageSize: 15
      },
      dataTableCacheName: 'SC-' + this.$route.name + '-data-table',
      columns: [{
        label: '经销商',
        prop: 'manuId',
        checked: true,
        width: 200,
        formatter: function formatter(val) {
          var findRow = _this.manufacturerList.find(function (item) {
            return item.ID === val;
          });

          if (findRow) {
            return findRow.name;
          }
        }
      }, {
        label: '客户类型',
        prop: 'clientType',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          var findRow = _this.clientTypeList.find(function (item) {
            return item.ID === val;
          });

          if (findRow) {
            return findRow.name;
          }
        }
      }, {
        label: '客户名称',
        prop: 'username',
        checked: true,
        width: 150
      }, {
        label: '备注',
        prop: 'mark',
        checked: true,
        width: 200
      }, {
        label: '操作',
        prop: 'operations',
        checked: true,
        width: 150,
        fixed: 'right',
        slot: 'operations',
        dragIgnore: true,
        fixedWidth: true
      }],
      manufacturerList: [],
      initialized: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this2;
                that.dataLoading = false;
                that.dataList = [];
                that.searchForm.manuId = null;
                that.searchForm.page = 1;
                that.searchForm.total = 0;
                that.clientTypeList = listClientType();

                if (that.initialized) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return that.loadManufacturer();

              case 10:
                _context.next = 12;
                return that.loadData();

              case 12:
                that.initialized = true;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this3;

                if (!that.dataLoading) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                that.dataList = [];
                that.dataLoading = true;
                _context2.next = 7;
                return listCustom(that.searchForm).then(function (res) {
                  that.dataList = res.list;
                  that.searchForm.total = res.total;
                }).catch(function (e) {});

              case 7:
                that.dataLoading = false;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    loadManufacturer: function loadManufacturer() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this4;
                that.manufacturerList = [];
                _context3.next = 4;
                return listDealerUserManufacturer().then(function (res) {
                  that.manufacturerList = res.list;
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    searchFormSubmit: function searchFormSubmit() {
      var that = this;
      that.searchForm.page = 1;
      that.searchForm.total = 0;
      that.loadData();
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.searchForm.page = page;
      that.loadData();
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.searchForm.pageSize = pageSize;
      that.searchForm.page = 1;
      that.loadData();
    },
    dataRowDbClick: function dataRowDbClick(row) {
      var that = this;
      that.dataEdit(row);
    },
    dataCreate: function dataCreate() {
      var that = this;
      var row = {
        id: null,
        manuId: that.searchForm.manuId
      };
      that.$refs.FormComponentRef.init(row);
    },
    dataEdit: function dataEdit(row) {
      var that = this;
      that.$refs.FormComponentRef.init(row);
    },
    dataDelete: function dataDelete(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, form, rows;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                form = {
                  ids: []
                };

                if (row) {
                  form.ids = [row.ID];
                } else {
                  rows = that.$refs.dataTableRef.selections();
                  form.ids = rows.map(function (item) {
                    return item.ID;
                  });
                }

                if (!(form.ids.length === 0)) {
                  _context5.next = 6;
                  break;
                }

                that.$message.error('请选择要删除的数据');
                return _context5.abrupt("return");

              case 6:
                that.$confirm('此操作将删除' + form.ids.length + '条数据, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.prev = 0;
                          _context4.next = 3;
                          return deleteCustom(form);

                        case 3:
                          that.loadData();
                          _context4.next = 8;
                          break;

                        case 6:
                          _context4.prev = 6;
                          _context4.t0 = _context4["catch"](0);

                        case 8:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, null, [[0, 6]]);
                }))).catch(function (e) {});

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};